"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _InputContainer = _interopRequireDefault(require("../InputContainer"));

var _SelectNativeRaw = _interopRequireDefault(require("../SelectNativeRaw"));

var _useSelectState2 = _interopRequireDefault(require("../useSelectState"));

var __jsx = _react["default"].createElement;

function SelectNative(props) {
  var _useSelectState = (0, _useSelectState2["default"])(props),
      setValue = _useSelectState.setValue,
      value = _useSelectState.value,
      valueObject = _useSelectState.valueObject,
      options = _useSelectState.options,
      empty = _useSelectState.empty;

  var _useSelectState$filte = _useSelectState2["default"].filterProps(props),
      _useSelectState$filte2 = _useSelectState$filte.placeholder,
      placeholder = _useSelectState$filte2 === void 0 ? "Select" : _useSelectState$filte2,
      _useSelectState$filte3 = _useSelectState$filte.allowEmpty,
      allowEmpty = _useSelectState$filte3 === void 0 ? true : _useSelectState$filte3,
      restProps = (0, _objectWithoutProperties2["default"])(_useSelectState$filte, ["placeholder", "allowEmpty"]);

  var optionElems = [];

  if (allowEmpty) {
    optionElems.push(__jsx("option", {
      disabled: true,
      value: "",
      key: "__default__"
    }, placeholder));
  }

  options.map(function (_ref) {
    var id = _ref.id,
        label = _ref.label,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled;
    optionElems.push(__jsx("option", {
      value: id,
      key: id,
      disabled: disabled
    }, label));
  });
  var selectValue = valueObject ? valueObject.id : "";
  return __jsx(_InputContainer["default"], (0, _extends2["default"])({}, restProps, {
    empty: empty,
    label: props.label || props.placeholder,
    showArrow: "inline",
    cursor: "pointer"
  }), __jsx(_SelectNativeRaw["default"], {
    sx: {
      height: "100%",
      width: "100%",
      cursor: "pointer"
    },
    onChange: function onChange(e) {
      setValue(!e.target.value || e.target.value === "" ? null : e.target.value);
    },
    value: selectValue
  }, optionElems));
}

var _default = SelectNative;
exports["default"] = _default;